import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { buildNavigation, buildRoute } from 'modules/core/lib/react-router'

const OrgChartPage = React.lazy(() => import('modules/org_chart/pages/OrgChartPage'))

const NewJobRoleModalPage = React.lazy(
  () => import('modules/job_catalog/pages/NewJobRoleModalPage')
)
const RoleCreatedModalPage = React.lazy(
  () => import('modules/org_chart/pages/RoleCreatedModalPage')
)

export const orgChartRoutes = buildNavigation((navigation) => {
  return [
    buildRoute({
      path: navigation.employees.organizationChart.path,
      element: <OrgChartPage />,
      handle: {
        meta: () => ({
          title: i18n.t('employees.orgchart.meta_title'),
          description: i18n.t('employees.orgchart.meta_title'),
        }),
      },
      children: [
        {
          path: navigation.employees.organizationChart.addJobCatalogRole.path,
          element: <NewJobRoleModalPage />,
        },
        {
          path: navigation.employees.organizationChart.jobCatalogRoleCreated.path,
          element: <RoleCreatedModalPage />,
        },
      ],
    }),
  ]
})
